import React from 'react';

import Message from 'components/Message';

import messages from './GuaranteedMinimumPanel.messages';
import SmartRateTopicPanelLayout from './SmartRateTopicPanelLayout';

const GuaranteedMinimumPanel = () => (
  <SmartRateTopicPanelLayout
    summaryBody={<Message as="p" message={messages.summaryBodyParagraph1} />}
    summaryHeading={messages.summaryHeading}
  />
);

export default GuaranteedMinimumPanel;
